export const NS_BAR_QUANTITY = {
    "05B0C0CA-AFCA-47B9-A47C-70E9FEE6CFBA": {
        // 2 Bars
        image: {
            default: "https://assets.rhinorack.com/Solution/NS-Bar-Quantity-2.png"
        }
    },
    "F47DFC39-B0CE-4A13-A982-1E49B008B488": {
        // 4 bars
        image: {
            default: "https://assets.rhinorack.com/Solution/NS-Bar-Quantity-4.png"
        },
    },
    "B07DEEA7-33DD-4470-89C8-811C1A3BF067": {
        // 6 bars
        image: {
            default: "https://assets.rhinorack.com/Solution/NS-Bar-Quantity-6.png"
        },
    }
};

export const NS_BAR_QUANTITY_2 = "05B0C0CA-AFCA-47B9-A47C-70E9FEE6CFBA";
export const NS_BAR_QUANTITY_2_IMAGE = {
    // 2 Bars
    image: {
        default: "https://assets.rhinorack.com/Solution/NS-Bar-Quantity-2.png"
    }
};


export const NS_BAR_QUANTITY_4 = "F47DFC39-B0CE-4A13-A982-1E49B008B488";
export const NS_BAR_QUANTITY_4_IMAGE = {
    // 4 Bars
    image: {
        default: "https://assets.rhinorack.com/Solution/NS-Bar-Quantity-4.png"
    }
};
export const NS_BAR_QUANTITY_6 = "B07DEEA7-33DD-4470-89C8-811C1A3BF067";
export const NS_BAR_QUANTITY_6_IMAGE = {
    // 6 Bars
    image: {
        default: "https://assets.rhinorack.com/Solution/NS-Bar-Quantity-6.png"
    }
};
